import { render, staticRenderFns } from "./Diagnose.vue?vue&type=template&id=2effcbd9&scoped=true"
import script from "./Diagnose.vue?vue&type=script&lang=js"
export * from "./Diagnose.vue?vue&type=script&lang=js"
import style0 from "./Diagnose.vue?vue&type=style&index=0&id=2effcbd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2effcbd9",
  null
  
)

export default component.exports